var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center h-100"},[_c('Preloader')],1):_c('EditProfile',{attrs:{"userId":_vm.userId,"userData":_vm.tableDataEdit,"isUserProfile":false,"isMyProfile":"","breadcrumbs":[
    {
      text: 'Home',
      to: { name: 'home' },
    },
    {
      text: 'My profile',
      click: () => _vm.onCloseClick(),
    }
  ]},on:{"close":_vm.onCloseClick,"profileUpdate":_vm.onProfileUpdate,"avatarUpdate":_vm.onAvatarUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }